module.exports = __webpack_public_path__ + "static/media/funds.72450d27.png";